import { render, staticRenderFns } from "./rtsm-tooltip-content.vue?vue&type=template&id=564b64e7&"
import script from "./rtsm-tooltip-content.vue?vue&type=script&lang=js&"
export * from "./rtsm-tooltip-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rtsm-tooltip-content.vue"
export default component.exports